import { CloseIcon } from "../Icons/Icons";

interface Props {
    children: React.ReactNode;
    open: boolean;
    onClose: () => void;
}

const ImageModal: React.FC<Props> = ({ children, open, onClose }) => {
    return (
        /* --- Backdrop --- */
        <div className={`fixed z-50 inset-0 flex justify-center items-center transition-colors
                      ${ open ? "visible bg-black/75" : "invisible" }`}
             onClick={onClose}>
            {/* Modal */}
            <div className="relative px-2 lg:px-0 lg:w-3/4 touch-auto"
                 onClick={(e) => { e.stopPropagation() }}>
                <figure className="overflow-auto"
                        style={{ touchAction: "pinch-zoom" }}>
                    { children }
                </figure>

                <button className="absolute top-3 right-5 lg:right-3 bg-first-solid rounded-full
                                   p-2 lg:p-4 border-2 border-fifth-solid text-fifth-solid
                                   transition-colors duration-200 ease-out
                                 hover:bg-forth-solid hover:text-first-solid 
                                 hover:border-first-solid"
                        onClick={onClose}>
                    <CloseIcon/>
                </button>
            </div>
        </div>
    );
}

export default ImageModal;
